import React, {useState, useCallback} from 'react'
import { motion } from "framer-motion"
import styles from '../CatalogItems.module.scss'
import { v4 as uuidv4 } from 'uuid'
import ProductСard from '../../ProductСard/ProductСard'
import ProductСardMin from '../../ProductСard/ProductСardMin'
import { arrHORECA} from '../../../utils/ProductСard'
import { arrHOUSEHOLD } from '../../../utils/ProductСard'
import { arrUNIVERSAL } from '../../../utils/ProductСard'
import { arrCONSTRUCTION } from '../../../utils/ProductСard'
import { arrTABLECLOTHS } from '../../../utils/ProductСard'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules';
import ScreenSize from '../../../hooks/ScreenSize'
import 'swiper/scss'
import 'swiper/scss/navigation'
import Annotation from '../../Annotation/Annotation'


const Packages = () => {

    const width = ScreenSize()

    const [isStandart, setIsStandart] = useState(1)

    const handleBackgroundOneOne = useCallback(() => {
        setIsStandart(1)
    }, []);

    const handleBackgroundOneTwo = useCallback(() => {
        setIsStandart(2)
    }, []);

    const handleBackgroundThree = useCallback(() => {
        setIsStandart(3)
    }, []);

    const handleBackgroundOneFive = useCallback(() => {
        setIsStandart(5)
    }, []);

    const handleBackgroundOneSix = useCallback(() => {
        setIsStandart(6)
    }, []);


    return (
                <motion.div className={styles.item}>
                    <ul className={styles.list_link_box}>
                        <li className={`${isStandart === 1 ? styles.link_blue : styles.link}`} onClick={handleBackgroundOneOne}>ХОЗЯЙСТВЕННЫЕ
                        </li>
                        <li className={`${isStandart === 2 ? styles.link_blue : styles.link}`} onClick={handleBackgroundOneTwo}>УНИВЕРСАЛЬНЫЕ</li>
                        <li className={`${isStandart === 5 ? styles.link_blue : styles.link}`} onClick={handleBackgroundOneFive}>СТРОИТЕЛЬНЫЕ</li>
                        <li className={`${isStandart === 6 ? styles.link_blue : styles.link}`} onClick={handleBackgroundOneSix}>HORECA</li>
                        <li className={`${isStandart === 3 ? styles.link_blue : styles.link}`} onClick={handleBackgroundThree}>СКАТЕРТИ</li>
                    </ul>
                    <div className={`${isStandart === 1 ? styles.cell : styles.cell_none}`}>
                        <p className={styles.text}><span>СЕРИЯ ХОЗЯЙСТВЕННЫЕ</span> - изготовлена по технологии двухслойной экструзии, что позволяет получать повышенную прочность в среднем на 25-30% по сравнению  пакетами аналогичной толщины изготовленным обычным эктрузионным  способом. Благодаря этому пакеты серии ХОЗЯЙСТВЕННЫЕ более выгодное приобретение так как получаете пакеты по приемлемой цене но с более высокими потребительскими свойствами.</p>
                        <ul className={styles.list}>
                                {arrHOUSEHOLD.map((item, index) => {
                                        return(
                                            <ProductСard 
                                                item={item}
                                                key={index} 
                                            />    
                                        ) 
                                })}         
                        </ul>
                        {width <= 600 ? <Annotation/> : ''}
                        <div className={styles.list_min}>
                            <Swiper
                                                spaceBetween={20}
                                                slidesPerView={1}
                                                centeredSlides={true}
                                                loop={false}
                                                modules={[Navigation]}
                                                breakpoints={{
                                                    0: {
                                                        slidesPerView: 1.2,
                                                        spaceBetween: 10,
                                                    },
                                                    768: {
                                                        slidesPerView: 1,
                                                        spaceBetween: 15,
                                                    },
                                                    1080: {
                                                        slidesPerView: 1,
                                                        spaceBetween: 20,
                                                    },
                                                }}
                                            >
                                        {arrHOUSEHOLD.map((item, index) => {
                                            const keyUid = uuidv4()
                                                return(
                                                    <SwiperSlide key={keyUid}>
                                                        <ProductСard 
                                                            item={item}
                                                        /> 
                                                        </SwiperSlide>     
                                                ) 
                                        })}  
                            </Swiper>
                        </div>
                    </div>
                    <div className={`${isStandart === 2 ? styles.cell : styles.cell_none}`}>
                        <p className={styles.text}><span>СЕРИЯ УНИВЕРСАЛЬНЫЕ</span> - производятся из цветного полиэтилена, поэтому могут быть использованы как и универсальные пакеты для упаковки больших вещей (одежды,обуви и др.) так и для мусора. В данной серии  представлены пакеты различной толщины от 25 мкм до 70 мкм. Так же в этой серии представлены пакеты под <span>мусорные баки 120 литров и 240 литров</span> подходящих для баков основных производителей ( Тарра, АЙ-Пласт и др.) Они изготовлены с учетом всех особенностей пластиковых баков с крышками.</p>
                        <ul className={styles.list}>
                                {arrUNIVERSAL.map((item, index) => {
                                    const keyUid = uuidv4()
                                        return(
                                            <ProductСard 
                                                item={item}
                                                key={keyUid}
                                            />    
                                        ) 
                                })}         
                        </ul>
                        {width <= 600 ? <Annotation/> : ''}
                        <div className={styles.list_min}>
                            <Swiper
                                                spaceBetween={20}
                                                slidesPerView={1}
                                                centeredSlides={true}
                                                loop={false}
                                                modules={[Navigation]}
                                                breakpoints={{
                                                    0: {
                                                        slidesPerView: 1.2,
                                                        spaceBetween: 10,
                                                    },
                                                    768: {
                                                        slidesPerView: 1,
                                                        spaceBetween: 15,
                                                    },
                                                    1080: {
                                                        slidesPerView: 1,
                                                        spaceBetween: 20,
                                                    },
                                                }}
                                            >
                                        {arrUNIVERSAL.map((item, index) => {
                                            const keyUid = uuidv4()
                                                return(
                                                    <SwiperSlide key={keyUid}>
                                                        <ProductСard 
                                                            item={item}
                                                        /> 
                                                        </SwiperSlide>     
                                                ) 
                                        })}  
                            </Swiper>
                        </div>
                    </div>
                    <div className={`${isStandart === 5 ? styles.cell : styles.cell_none}`}>
                        <p className={styles.text}><span>СЕРИЯ СТРОИТЕЛЬНЫЕ</span> - позволяет их использовать для необходимо повышенная прочность обусловленная повышенными нагрузками. Данные пакеты производятся из более толстых пленок и с использование специальных добавок которые позволяют получать более крепкие пакеты.</p>
                        <ul className={styles.list}>
                                {arrCONSTRUCTION.map((item, index) => {
                                    const keyUid = uuidv4()
                                        return(
                                            <ProductСard 
                                                item={item}
                                                key={keyUid}
                                            />    
                                        ) 
                                })}         
                        </ul>
                        {width <= 600 ? <Annotation/> : ''}
                        <div className={styles.list_min}>
                            <Swiper
                                                spaceBetween={20}
                                                slidesPerView={1}
                                                centeredSlides={true}
                                                loop={false}
                                                modules={[Navigation]}
                                                breakpoints={{
                                                    0: {
                                                        slidesPerView: 1.2,
                                                        spaceBetween: 10,
                                                    },
                                                    768: {
                                                        slidesPerView: 1,
                                                        spaceBetween: 15,
                                                    },
                                                    1080: {
                                                        slidesPerView: 1,
                                                        spaceBetween: 20,
                                                    },
                                                }}
                                            >
                                        {arrCONSTRUCTION.map((item, index) => {
                                            const keyUid = uuidv4()
                                                return(
                                                    <SwiperSlide>
                                                        <ProductСard 
                                                            item={item}
                                                            key={keyUid}
                                                        /> 
                                                        </SwiperSlide>     
                                                ) 
                                        })}  
                            </Swiper>
                        </div>
                    </div>                    
                    <div className={`${isStandart === 6 ? styles.cell : styles.cell_none}`}>
                        <p className={styles.text}><span>СЕРИЯ HORECA</span> - предлагает пакеты используемые в клининге, гостиницах и прочих местах где постоянное использование  предполагает быструю замену  пакета даже если он не будет наполнен полностью. Использование данной серии пакетов позволяет экономить и при этом не будет страдать качество обслуживания. Кроме того эти пакеты могут быть использованы где не предполагается большой объем отходов а не масса.</p>
                        <ul className={styles.list}>
                                {arrHORECA.map((item, index) => {
                                    const keyUid = uuidv4()
                                        return(
                                            <ProductСard 
                                                item={item}
                                                key={keyUid}
                                            />    
                                        ) 
                                })}         
                        </ul>
                        {width <= 600 ? <Annotation/> : ''}
                        <div className={styles.list_min}>
                            <Swiper
                                                spaceBetween={20}
                                                slidesPerView={1}
                                                centeredSlides={true}
                                                loop={false}
                                                modules={[Navigation]}
                                                breakpoints={{
                                                    0: {
                                                        slidesPerView: 1.2,
                                                        spaceBetween: 10,
                                                    },
                                                    768: {
                                                        slidesPerView: 1,
                                                        spaceBetween: 15,
                                                    },
                                                    1080: {
                                                        slidesPerView: 1,
                                                        spaceBetween: 20,
                                                    },
                                                }}
                                            >
                                        {arrHORECA.map((item, index) => {
                                            const keyUid = uuidv4()
                                                return(
                                                    <SwiperSlide>
                                                        <ProductСard 
                                                            item={item}
                                                            key={keyUid}
                                                        /> 
                                                        </SwiperSlide>     
                                                ) 
                                        })}  
                            </Swiper>
                        </div>
                        
                    </div>
                    <div className={`${isStandart === 3 ? styles.cell : styles.cell_none}`}>
                        <p className={styles.text}><span>Одноразовые скатерти в рулоне</span>, удобно использовать там где необходимо создать быстро чистую поверхность что разложить еду и напитки или для других целей, и потом так же быстро её убрать после не оставляя мусор. Основная особенность наших одноразовых скатертей что при общей длине рулона 11 метров и шириной 1.1 м.  это линия отрыва,  каждые 1.1 метра которая позволяет получить 10 скатертей 1.1х1.1 или 5 скатертей 1.1.х2.2 или 2 скатерти 1.1х5.5 либо другое сочетание размеров.</p>
                        <p className={styles.text}></p>
                        <ul className={styles.list}>
                                {arrTABLECLOTHS.map((item, index) => {
                                    const keyUid = uuidv4()
                                        return(
                                            <ProductСardMin 
                                                item={item}
                                                key={keyUid}
                                            />    
                                        ) 
                                })}         
                        </ul>
                        {width <= 600 ? <Annotation/> : ''}
                        <div className={styles.list_min}>
                            <Swiper
                                                spaceBetween={20}
                                                slidesPerView={1}
                                                centeredSlides={true}
                                                loop={false}
                                                modules={[Navigation]}
                                                breakpoints={{
                                                    0: {
                                                        slidesPerView: 1.2,
                                                        spaceBetween: 10,
                                                    },
                                                    768: {
                                                        slidesPerView: 1,
                                                        spaceBetween: 15,
                                                    },
                                                    1080: {
                                                        slidesPerView: 1,
                                                        spaceBetween: 20,
                                                    },
                                                }}
                                            >
                                        {arrTABLECLOTHS.map((item, index) => {
                                            const keyUid = uuidv4()
                                                return(
                                                    <SwiperSlide>
                                                        <ProductСardMin 
                                                            item={item}
                                                            key={keyUid}
                                                        /> 
                                                        </SwiperSlide>     
                                                ) 
                                        })}  
                            </Swiper>
                        </div>
                        
                    </div>
                </motion.div>
    )
}

export default Packages